import { Pipe, PipeTransform } from "@angular/core";
import {Course} from "cli-types";

@Pipe({
    name: "courseSelectTitle",
    standalone: false
})
export class CourseSelectTitlePipe implements PipeTransform {
    transform(value: Course): string {

        if (
            !value ||
            value === null ||
            value === undefined
        ) {
            return "---";
        } else if (value.primaryTeacher) {
            return value.courseTitle + " : " + value.primaryTeacher.firstName + " " + value.primaryTeacher.lastName;
        } else {
            return value.courseTitle;
        }


    }
}
